import type { AttendanceStatus } from '@daghfal/core';

/** Each attendance status's badge colour and its words, for every attendance screen of the console. */
export const TONES: Record<AttendanceStatus, 'success' | 'info' | 'danger' | 'warning' | 'neutral'> = {
  Present: 'success', Departed: 'info', Absent: 'danger', NotifiedAbsence: 'warning', Expected: 'neutral',
};

export const LABELS: Record<AttendanceStatus, string> = {
  Present: 'attendance.present', Departed: 'attendance.departed', Absent: 'attendance.absent',
  NotifiedAbsence: 'attendance.notified', Expected: 'attendance.expected',
};
